import { useContext, useLayoutEffect, type ContextType } from 'react';

import DocumentContext from '../contexts/DocumentContext.context';

type TProps = {
  onChange: (session: ContextType<typeof DocumentContext> | null) => void;
};

// Hands the session to a page whose rail must stay mounted while its keyed DocumentProvider swaps documents.
const ShareDocumentSession = ({ onChange }: TProps) => {
  const session = useContext(DocumentContext);
  // Layout effects, so the rail never paints a session that is gone.
  useLayoutEffect(() => onChange(session), [session]);
  useLayoutEffect(() => () => onChange(null), []);
  return null;
};

export default ShareDocumentSession;
